import { createClient } from '@supabase/supabase-js';

// The anon key is public by design (it ships in the browser bundle); access is
// governed by Row Level Security policies on the Supabase side, not by secrecy.
const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Guard so a missing/misconfigured env doesn't throw at import time and blank
// the whole app — the data layer surfaces a friendly error instead.
export const supabase = url && anonKey ? createClient(url, anonKey) : null;
